export default {
	inputPriceCodeDisplay: {
		startDate: 'La date de soins ne peut pas être antérieure à cette date',
		endDate: 'La date de soins ne peut pas être postérieure à cette date ni à la date du jour'
	},
	priceCodeDisplay: [
		{
			id: 'code',
			label: 'Code forfait',
			tooltip: null
		},
		{
			id: 'amount',
			label: 'Montant',
			cellType: 'money',
			tooltip: null
		},
		{
			id: 'description',
			label: 'Acte de déclenchement',
			tooltip: null
		},
		{
			id: 'actorDetails',
			cellType: 'array',
			label: 'Destinataire de versement',
			tooltip: null
		},
		{
			id: 'effectiveStartDate',
			cellType: 'date',
			label: 'Date de début de validité',
			tooltip: 'La date de soins ne peut pas être antérieure à cette date'
		},
		{
			id: 'effectiveEndDate',
			cellType: 'date',
			label: 'Date de fin de validité',
			tooltip: 'La date de soins ne peut pas être postérieure à cette date ni à la date du jour'
		}
	],
	title: 'Mes codes forfaits',
	closeButton: 'J\'ai compris'
};
